type Props = {
	content: string;
};

export function InputError({ content }: Props) {
	return (
		<p style={{ margin: 0, fontSize: 13, color: "var(--accent-error)" }}>
			{content}
		</p>
	);
}
